<template>
  <div class="chart-percentage" v-if="chartData">
    <div class="title">
      <h2>{{ chartTitle }}</h2>
    </div>
    <div class="content">
      {{ chartContent }}
    </div>
    <div class="percentage-items">
      <div class="item" v-for="(item, index) in chartData.image" :key="index">
        <div class="photo">      
          <img v-if="item.image_path" :src="item.image_path" alt="" />
          <img v-else src="../../../assets/placeholder.png" alt="" />
        </div>
        <div class="title">{{ item.title }}</div>
        <div class="percentage">{{ item.percentage }} %</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChartPercentage",
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    chartTitle() {
      return this.lang === "zh_hk"
        ? this.chartData.title_zh_hk
        : this.chartData.title_en;
    },
    chartContent() {
      return this.lang === "zh_hk"
        ? this.chartData.content_zh_hk
        : this.chartData.content_en;
    },
  },
  data() {
    return {
      lang: "zh_hk",
    };
  },
  created() {
    this.getLanguage();
  },
  methods: {
    getLanguage() {
      this.lang = localStorage.getItem("locale") || this.lang;
    },
  },
};
</script>

<style lang="scss">
.chart-percentage {
  margin: 32px 0;
  text-align: center;
  padding: 16px 48px;
  border: 2px solid #5e98ca;
  // padding: 16px;
  border-radius: 16px;


  .content {
    margin: 24px 0;
  }

  .percentage-items {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .item {
      flex: 0 0 calc(20% - 24px); /* 20% (5 items) with 24px gap */
      margin: 16px;
      text-align: center;
      transition: 0.3s;

      .photo {
        img {
          max-width: 100px;
          width: 100%;
          height: auto;
          transition: 0.3s;
        }
      }

      .title {
        background: $theme-color1;
        color: white;
        font-size: 16px;
        margin-bottom: 8px;
        width: max-content;
        margin: 8px auto;
        padding: 4px;
        font-weight: bold;
        border-radius: 4px;
      }

      .percentage {
        background: $theme_colorF;
        color: white;
        font-size: 22px;
        // width: fit-content;
        margin: 8px auto;
        padding: 4px;
        font-weight: bold;
        border-radius: 4px;
      }

      &:hover{
            transform: scale(1.1);
          }
    }
  }
}
</style>
